import axios from 'axios';
import store from '@/store/'


// Account 相關的 api
const adminCalendar = axios.create({
    baseURL: process.env.VUE_APP_API_DOMAIN+'/admin'
});

//預約日期相關API
export const apiCalendarList = (data) => adminCalendar.get('/calendar',{
    params : data,
    headers:{
        'Authorization': `Bearer ${store.state.auth.accessToken}`
    }
});

//預約日期 單元 API
export const apiCalendarUnit = (data) => adminCalendar.get('/calendar/unit',{
    params : data,
    headers:{
        'Authorization': `Bearer ${store.state.auth.accessToken}`
    }
});

//新增訂單單元API
export const apiCalendarAddUnit = (data) => adminCalendar.post('/calendar/unit', data, {
    headers:{
        'Authorization': `Bearer ${store.state.auth.accessToken}`
    }
});

//更新訂單單元API
export const apiCalendarUpdateUnit = (data) => adminCalendar.put('/calendar/unit', data, {
    headers:{
        'Authorization': `Bearer ${store.state.auth.accessToken}`
    }
});

//刪除訂單單元API
export const apiCalendarDeleteUnit = (data) => adminCalendar.delete('/calendar/unit', {
    data: data,
    headers:{
        'Authorization': `Bearer ${store.state.auth.accessToken}`
    }
});

//批次更新時段延時開放API
export const apiCalendarBatchDelayedOpen = (data) => adminCalendar.put('/calendar/batch-delayed-open', data, {
    headers:{
        'Authorization': `Bearer ${store.state.auth.accessToken}`
    }
});

//批次刪除時段API
export const apiCalendarBatchDelete = (data) => adminCalendar.delete('/calendar/batch-delete', {
    data: data,
    headers:{
        'Authorization': `Bearer ${store.state.auth.accessToken}`
    }
});